export default "__VITE_ASSET__CVA_IohR__"